import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vle-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent {
  @Input() isAnimationDisabled: boolean;
}
